import React, { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Pagination, Navigation } from 'swiper/modules';
import 'swiper/swiper-bundle.css';
import './Clinica.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

const CarouselSlider = () => {
    const [modalVisible, setModalVisible] = useState(false);
    const [modalImage, setModalImage] = useState('');
    const modalTimeout = useRef(null); 

    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
            delay: 200,
        });
        
        return () => {
            if (modalTimeout.current) {
                clearTimeout(modalTimeout.current);
            }
        };
    }, []);

    const images = [
        '/images/clinica/clinica-01.webp',
        '/images/clinica/clinica-02.webp',
        '/images/clinica/clinica-03.webp',
        '/images/clinica/clinica-04.webp',
        '/images/clinica/clinica-06.webp',
        '/images/clinica/clinica-07.webp',
    ];

    const handleSlideClick = (index) => {
        setModalImage(images[index]); 
        setModalVisible(true);
        document.body.style.overflow = 'hidden';
    };

    const closeModal = () => {
        setModalVisible(false);
        setModalImage('');
        document.body.style.overflow = 'auto';
        if (modalTimeout.current) {
            clearTimeout(modalTimeout.current);
            modalTimeout.current = null;
        }
    };

    return (
        <div className="carousel-slider-container-clinic">
            <div className="carousel-header" data-aos="fade-up">
                <h2 className="carousel-title-banner">Conheça o consultório</h2>
                <p className="carousel-description">
                    Bem-vindo ao nosso consultório, um espaço onde a experiência em cirurgia plástica se une a uma abordagem personalizada nas necessidades de cada paciente.
                </p>
            </div>
            <Swiper
                modules={[EffectCoverflow, Pagination, Navigation]}
                effect="coverflow"
                grabCursor={true}
                centeredSlides={true}
                slidesPerView={2}
                loop={true}
                coverflowEffect={{
                    rotate: 0,
                    stretch: 0,
                    depth: 100,
                    modifier: 1,
                    slideShadows: true,
                }}
                pagination={{ clickable: true }}
                navigation
                data-aos="fade-up"
            >
                {images.map((image, index) => (
                    <SwiperSlide key={index}>
                        <div 
                            className="slide-clinic-wrapper"
                            onClick={() => handleSlideClick(index)}
                        >
                            <img 
                                src={image.replace('-full', '')}
                                alt={`Consultório Imagem ${index + 1}`}
                                className="slide-clinic-image"
                            />
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            <div className="navigate-to">
                <a href="/consultorio" className="custom-button">Saiba mais aqui</a>
            </div>

            {modalVisible && (
                <div className="modal-clinic" onClick={closeModal}>
                    <span className="close-button-clinic" onClick={closeModal}>&times;</span>
                    <img className="modal-content-clinic" src={modalImage} alt="Imagem Completa" />
                </div>
            )}
        </div>
    );
};

export default CarouselSlider;